import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import LooksOneRoundedIcon from "@mui/icons-material/LooksOneRounded";
import LooksTwoRoundedIcon from "@mui/icons-material/LooksTwoRounded";
import Looks3RoundedIcon from "@mui/icons-material/Looks3Rounded";
import Looks4RoundedIcon from "@mui/icons-material/Looks4Rounded";
import Looks5RoundedIcon from "@mui/icons-material/Looks4Rounded";
import LaunchIcon from "@mui/icons-material/Launch";

import { Chip } from "@mui/material";
import { Link } from "react-router-dom";

function EducationPage() {
  return (
    <div id="education">
      <div className="global-title" data-aos="fade-up">
        Education
      </div>
      <div className="global-subtitle" data-aos="fade-up">
        Milestones in Learning: My Journey Through Education
      </div>
      <Timeline position="left" className="timeline">
        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            variant="body2"
            color="text.secondary"
            className="timeline-content-op"
          >
            <div className="timeline-content-op" data-aos="fade-left">
              17/02/2025 - Present · 2 yrs{" "}
              <div>
                <Link
                  className="degree-link"
                  to="https://www.deakin.edu.au/course/master-information-technology"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong>
                    Master of Information Technology{" "}
                    <LaunchIcon fontSize="small" />
                  </strong>{" "}
                </Link>
              </div>
              {/* <div>• GPA: 3.26 </div> */}
              {/* <div>
                <strong>
                  <u>Projects Did for the University</u>
                </strong>
              </div>
              <div>• Ruhuna Hostel Management Web Site System.</div>
              <div>• Internal System for Dean's Office.</div> */}
            </div>
          </TimelineOppositeContent>
          <TimelineSeparator data-aos="fade-up">
            <TimelineConnector />
            <TimelineDot sx={{ bgcolor: "black" }}>
              <Looks5RoundedIcon />
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent data-aos="fade-right" sx={{ py: "12px", px: 2 }}>
            <div className="timeline-content">
              <div className="timeline-title">
                <img
                  className="timeline-image"
                  src="https://res.cloudinary.com/ddjpxsrej/image/upload/v1736397514/Deakin_University_j7bspi.svg"
                  alt="Deakin University"
                />{" "}
                &nbsp; &nbsp;
                <Link
                  className="company-link"
                  to="https://www.deakin.edu.au/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Deakin University <LaunchIcon fontSize="small" />
                </Link>
              </div>
              <div className="timeline-subtitle">Postgraduate Student</div>

              <div className="timeline-chips">
                <Chip
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  color="primary"
                  size="small"
                  label="Data Science"
                />
                &nbsp;
                <Chip
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  color="primary"
                  size="small"
                  label="Research"
                />{" "}
                &nbsp;
                <Chip
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  color="primary"
                  size="small"
                  label="Software Development"
                />
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            variant="body2"
            color="text.secondary"
            className="timeline-content-op"
          >
            <div className="timeline-content-op" data-aos="fade-left">
              24/07/2020 - 29/03/2024 · 3 yrs{" "}
              <div>
                <Link
                  className="degree-link"
                  to="https://www.sci.ruh.ac.lk/computer/bcs_general_degree.php"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong>
                    Bachelor of Computer Science Degree (General){" "}
                    <LaunchIcon fontSize="small" />
                  </strong>{" "}
                </Link>
              </div>
              <div>• GPA: 3.26 </div>
              <div>
                <strong>
                  <u>Projects Did for the University</u>
                </strong>
              </div>
              <div>• Ruhuna Hostel Management Web Site System.</div>
              <div>• Internal System for Dean's Office.</div>
            </div>
          </TimelineOppositeContent>
          <TimelineSeparator data-aos="fade-up">
            <TimelineConnector />
            <TimelineDot sx={{ bgcolor: "black" }}>
              <Looks4RoundedIcon />
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent data-aos="fade-right" sx={{ py: "12px", px: 2 }}>
            <div className="timeline-content">
              <div className="timeline-title">
                <img
                  className="timeline-image"
                  src="https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013144/uor_rkg4ev.webp"
                  alt="University of Ruhuna"
                />{" "}
                &nbsp;
                <Link
                  className="company-link"
                  to="https://ruh.ac.lk/index.php/en/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  University of Ruhuna (Gov) <LaunchIcon fontSize="small" />
                </Link>
              </div>
              <div className="timeline-subtitle">Undergraduate Student</div>

              <div className="timeline-chips">
                <Chip
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  color="primary"
                  size="small"
                  label="Computer Science"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="Mathematics"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="English"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="FYP"
                />
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            variant="body2"
            color="text.secondary"
            className="timeline-content-op"
          >
            <div className="timeline-content-op" data-aos="fade-left">
              2019 - 2020 · 1 yr{" "}
              <div>
                <strong>Bachelor of Computer Science Degree (Holded)</strong>
              </div>
            </div>
          </TimelineOppositeContent>
          <TimelineSeparator data-aos="fade-up">
            <TimelineConnector />
            <TimelineDot sx={{ bgcolor: "black" }}>
              <Looks3RoundedIcon />{" "}
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent data-aos="fade-right" sx={{ py: "12px", px: 2 }}>
            <div className="timeline-content">
              <div className="timeline-title">
                <img
                  className="timeline-image"
                  src="https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013144/iit_cgnikw.webp"
                  alt="Westminster"
                />{" "}
                &nbsp;
                <Link
                  className="company-link"
                  to="https://www.westminster.ac.uk/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  University of Westminster <LaunchIcon fontSize="small" />
                </Link>
              </div>
              <div className="timeline-subtitle">Undergraduate Student</div>
              <div className="timeline-chips">
                <Chip
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  color="primary"
                  size="small"
                  label="Computer Science"
                />
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            variant="body2"
            color="text.secondary"
            className="timeline-content-op"
          >
            <div className="timeline-content-op" data-aos="fade-left">
              Sep 2018 - Feb 2019 · 5 mos
              <div>
                <Link
                  className="degree-link"
                  to="https://www.nibm.lk/course/advanced-certificate-course-in-english-language"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong>
                    Advanced Certificate Course in English Language{" "}
                    <LaunchIcon fontSize="small" />
                  </strong>{" "}
                </Link>
              </div>
              <div>• Result : Merit. </div>
            </div>
          </TimelineOppositeContent>
          <TimelineSeparator data-aos="fade-up">
            <TimelineConnector />
            <TimelineDot sx={{ bgcolor: "black" }}>
              <LooksTwoRoundedIcon />
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent data-aos="fade-right" sx={{ py: "12px", px: 2 }}>
            <div className="timeline-content">
              <div className="timeline-title">
                <img
                  className="timeline-image"
                  src="https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013152/nibm_wblfm2.webp"
                  alt="NIBM"
                />{" "}
                &nbsp;
                <Link
                  className="company-link"
                  to="https://www.nibm.lk/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  NIBM <LaunchIcon fontSize="small" />
                </Link>
              </div>
              <div className="timeline-subtitle">Student</div>
              <div className="timeline-chips">
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="English"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="Presentations"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="Speaking"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="Listening"
                />
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            variant="body2"
            color="text.secondary"
            className="timeline-content-op"
          >
            <div className="timeline-content-op" data-aos="fade-left">
              2005 - 2018
              <div>
                <strong>
                  <u>Prices, Clubs and Positions</u>
                </strong>
              </div>
              <div>• Editor of ICT society (2018). </div>
              <div>• Won the N.A.L COORAY MEMORIAL PRIZE for ICT (2018).</div>
              <div>• Member Wild life association (2018). </div>
              <div>• Leader of the House march (2017). </div>
              <div> • Member of Astronomy Club (2016).</div>
              <div>
                <strong>
                  <u>A/L Results</u>
                </strong>
              </div>
              <div>
                • Grade: MATH: C, PHYSICS: C,
                <br />
                &nbsp;&nbsp;&nbsp;INFORMATION AND COMMUNICATION: B.
              </div>
              <div>• Rank: 48th Colombo.</div>
            </div>
          </TimelineOppositeContent>
          <TimelineSeparator data-aos="fade-up">
            <TimelineConnector />
            <TimelineDot sx={{ bgcolor: "black" }}>
              <LooksOneRoundedIcon />
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent data-aos="fade-right" sx={{ py: "12px", px: 2 }}>
            <div className="timeline-content">
              <div className="timeline-title">
                <img
                  className="timeline-image"
                  src="https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013144/wesley_phdnry.webp"
                  alt="Wesley College"
                />{" "}
                &nbsp;
                <Link
                  className="company-link"
                  to="https://www.facebook.com/WesleyCollegeColomboSriLanka/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Wesley College, Colombo <LaunchIcon fontSize="small" />
                </Link>
              </div>
              <div className="timeline-subtitle">School Student</div>

              <div className="timeline-chips">
                <Chip
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  color="primary"
                  size="small"
                  label="O/Ls"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="A/Ls - Maths Stream with ICT"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="Sports"
                />
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </div>
  );
}

export default EducationPage;
